import { InvoiceParams, InvoiceResultModel, getADIInvoices } from "@NA/Services/ADIInvoiceService";
import { getVisualCarousal } from "@NA/Services/GetVisualCarousal";
// import { SystemStatusModel, getSystemStatus } from "@NA/Services/ADIStatusService"; // Code from Spire Prod
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<InvoiceParams, InvoiceResultModel>;

export const leadingZero = (value: number) => {
    if (value < 10) {
        return "0" + value.toString();
    }
    return value.toString();
};

// The below commented code is taken from Spire Prod 
// export const SetErpSystemStatus: HandlerType = async (props: any) => {
//     const systemStatusModel = await getSystemStatus();
//     const model: SystemStatusModel = JSON.parse(JSON.stringify(systemStatusModel));

//     if (model.adonis.wor === "Y") {
//         props.apiResult = {
//             ...props.apiResult,
//             isErpAvailable: false,
//         }
//     } else {
//         props.apiResult = {
//             ...props.apiResult,
//             isErpAvailable: true,
//         }
//     }
// };

export const DefaultDate = (from: boolean, clear: boolean, numDays: number = 180) => {
    let now = new Date();
    let today = new Date();
    let toDate = new Date();
    now.setTime(now.getTime() - numDays * 24 * 60 * 60 * 1000);
    if (!clear && from) {
        return  leadingZero(now.getMonth() + 1) + "/" + leadingZero(now.getDate()) + "/" + now.getFullYear();
    } else if (clear && from) {
        return leadingZero(now.getMonth() + 1) + "/" + leadingZero(now.getDate()) + "/" + now.getFullYear();
    } else if (clear && !from) {
        return leadingZero(today.getMonth() + 1) + "/" + leadingZero(today.getDate()) + "/" + today.getFullYear();
    } else if (!clear && !from) {
        return  leadingZero(toDate.getMonth() + 1) + "/" + leadingZero(toDate.getDate()) + "/" + toDate.getFullYear();
    }
};

export const invoiceParams: InvoiceParams = {
    customerSequence: "-1",
    sort: "invoiceDate DESC",
    dateType: "180days",
    toDate: DefaultDate(false, false) || "",
    fromDate: DefaultDate(true, false) || "",
    poNumber: "",
    invoiceNumber: "",
    refrencenumber: "",
    invoiceType: "1",
    invoiceTypeDesc: "Open",
    selectedpage: 1,
    isSearch: false,
    showOpenOnly: true,
    dateRange: "180days",
    dateRangeDesc: "Last 180 days",
    invoiceFilterType: "type",
    invoiceFilterData: "0",
    dpdFilterType: "dpd",
    dpdFilterData: "0",
    properties: "",
    page: "1",
    pageSize: "12",
    formattedFromDate: "",
};

export const DispatchADIInvoice: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/LoadADIInvoice",
        result: props.parameter,
    });
};

export const LoadADIInvoice: HandlerType = async (props: any) => {
    type InputObject = {
        [key: string]: any;
    };

    type OutputObject = {
        [key: string]: any;
    };

    function removeEmptyKeys(obj: InputObject): OutputObject {
        const result: OutputObject = {};

        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
                result[key] = obj[key];
            }
        }

        return result;
    }

    props.apiResult = await getADIInvoices(removeEmptyKeys(props.parameter));
};

export const DispatchCompleteLoadADIInvoice: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteADIInvoice",
        ADIInvoiceResult: props.apiResult,
    });
};

export const chain = [DispatchADIInvoice, LoadADIInvoice , DispatchCompleteLoadADIInvoice]; // As per P21 Change
// export const chain = [DispatchADIInvoice, LoadADIInvoice, SetErpSystemStatus, DispatchCompleteLoadADIInvoice]; // code from Spire Prod

const loadADIInvoices = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        ...invoiceParams,
    },
    "loadADIInvoices",
);
export default loadADIInvoices;
